// Set up dynamic data for film header. Currently only the CTA text.
(function (jQuery, Drupal, once) {
  Drupal.behaviors.film_hero = {
    attach: function (context) {
      const selector = '[data-component-id="nuplayer:film_hero"]';
      once('film-hero--processed', selector, context).forEach((filmHeroJQ) => {
        const filmHero = jQuery(filmHeroJQ)[0];
        // Set the button CTA text
        const filmId = filmHero.dataset.filmId;
        const pillar = filmHero.dataset.pillar;
        const ctaText = filmHero.querySelector(
          '.cta-main [data-component-id="nuplayer:heading_4"]'
        );
        if (!ctaText) {
          // CTA text element not found in film hero.
          return;
        }
        if (pillar === 'rentals') {
          // Film CTA text needs to be set dynamically based on entitlements and membership.
          // If neither, show the default CTA text.
          Promise.all([
            Drupal.behaviors.nuplayer.EntSubs.fetchEntitlementCopy(filmId, pillar),
            Drupal.behaviors.nuplayer.MembershipPrice.fetchMembershipPrice(filmId),
          ])
            .then(([entitlementData, membershipData]) => {
              // If the user has purchased the film, show the entitlement CTA text.
              if (typeof entitlementData === 'object' && !Array.isArray(entitlementData)) {
                const filmData = entitlementData[filmId];
                if (filmData && filmData.cta) {
                  ctaText.textContent = filmData.cta;
                  return;
                }
              }
              // If the user has a membership, show the membership price.
              if (typeof membershipData === 'object' && !Array.isArray(membershipData)) {
                const filmData = membershipData[filmId];
                if (filmData && filmData.price) {
                  ctaText.textContent = filmData.price;
                }
              }
            })
            .catch((error) => {
              console.error('Error fetching entitlement or membership data:', error);
            });
        } else if (pillar === 'subscription') {
          Drupal.behaviors.nuplayer.Subscriber.fetchSubscriptionLabels([filmId])
            .then((labels) => {
              if (labels && labels[filmId]) {
                ctaText.textContent = labels[filmId].cta;
              }
            })
            .catch((error) => {
              console.error('Error fetching subscription labels:', error);
            });
        }
      });
    },
  };
})(jQuery, Drupal, once);
